import styled from 'styled-components'
import { colors } from '@sabavision/dio'

const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  background: ${colors.cultured};
  font-family: IRANSans;
  overflow-x: hidden;
`
export { Wrapper }

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`
export { Container }

const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  background: ${colors.white};
  margin-block: 6px 8px;
  padding-block: 16px 13px;
  padding-inline: 40px 29px;
  margin-inline: 16px;
  .create {
    display: flex;
    gap: 7px;
  }
`
export { Actions }

const AdsContainer = styled.div`
  // display: flex;
  // border-radius: 8px;
  // background: ${colors.white};
  // margin-bottom: 8px;
  // padding-block: 24px;
  // padding-inline: 22px;
  // flex-grow: 1;
  // margin-inline: 16px;
`
export { AdsContainer }
